<template>
  <div class="row mt-md-1 mt-sm-1 mt-lg-1">
    <div class="col-xs-6 col-sm-6 start-xs start-sm" v-show="!loading">
      <div class="container-buttons">
        <b-dropdown :text="selected.text" variant="primary" size="sm">
          <b-dropdown-item-button v-for="(chart, i) in colNames" :key="chart.value"
            @click="changeDropdownLeft(chart, i)" :disabled="selectedRight && selectedRight.text == chart.text">
            {{ chart.text }}
          </b-dropdown-item-button>
        </b-dropdown>
        <b-dropdown :text="!selectedRight.value ? 'SELECIONAR' : selectedRight.text"
          :disabled="selected.text === 'VOLUME' || selected.text === 'LÂMINA'" variant="success" size="sm"
          class="ml-md-2" v-if="colNames.length > 1">
          <b-dropdown-item-button v-for="(chart, i) in colNamesRight" :key="i" @click="selectedRight = chart" :disabled="
            chart.text == selected.text &&
            selected.text === colNamesRight[i].text
          ">
            {{ chart.text }}
          </b-dropdown-item-button>
        </b-dropdown>
      </div>
    </div>

    <div class="col-xs-6 col-sm-6 end-xs btn-left" v-show="!loading">
      <b-btn-group>
        <b-btn v-for="p in periods" :key="p" size="sm" variant="primary" @click="changeDataByPeriod(p)"
          :disabled="p == period">{{ p }}</b-btn>
      </b-btn-group>
    </div>

    <div class="col-xs-12 center-xs graficos">
      <div v-if="!hasChart && loading">
        <spinner /> Desenhando o gráfico. Por favor, aguarde...
      </div>
      {{ noChartWarning }}
      <apexchart v-if="hasChart" width="100%" height="425" :series="series" :options="options"></apexchart>
    </div>

    <div class="col-xs-12 highlights ml-2 row">
      <div class="col-xs-12 p-0 row around-xs card-container" v-for="(highlight, index) in highlights" :key="index">
        <h5 class="col-xs-12 card-name p-1 m-0" :style="`background-color:${highlight.color};color:#fff`">
          {{ highlight.name }}
        </h5>
        <div class="col-xs-6 col-sm-3 center-xs p-2">
          <div class="hl-data">
            <h4>{{ highlight.min }}</h4>
            <div class="hl-unit">{{ highlight.unit }}</div>
          </div>
          <div class="hl-">Mínimo</div>
          <span class="hl-detail">
            {{ formatDate(highlight.minDates) }}
          </span>
        </div>
        <div class="col-xs-6 col-sm-3 center-xs p-2">
          <div class="hl-data">
            <h4>{{ highlight.avg }}</h4>
            <div class="hl-unit">{{ highlight.unit }}</div>
          </div>
          <div class="hl-">Média</div>
          <div class="hl-detail">{{ highlight.length + " leituras" }}</div>
        </div>
        <div class="col-xs-6 col-sm-3 center-xs p-2">
          <div class="hl-data">
            <h4>{{ highlight.max }}</h4>
            <div class="hl-unit">{{ highlight.unit }}</div>
          </div>
          <div class="hl-">Máximo</div>
          <span class="hl-detail">
            {{ formatDate(highlight.maxDates) }}
          </span>
        </div>
      </div>
    </div>
    <div class="col-xs-12 mt-2 mr-2">
      <TabulatorEvents v-if="eqp" :fetch-page="fetchEventsPage" :on-create="createEvent" :equipment-name="name" :is-mobile="isMobile" />
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { monitChart, listEquipments } from "@/api";
import TabulatorEvents from "@/pages/components/shared/TableEvents.vue";
// import { cookies } from "@/pages/components/cookies";
import { organizeLog } from "@/pages/components/monit/charts";
export default {
  name: "actuator-charts",
  components: {
    TabulatorEvents,
  },
  props: {
    eqp: String,
    name: String,
    colNames: Array,
    columns: Array,
    showAxesZero: {
      type: Boolean,
      value: false,
    },
    currentlyValues: Object,
    area: Number,
    items: [Object, Array],
    isMobile: Boolean,
    actuatorId: [String, Number],
    isPump: Boolean,
    hasFeedbackSensor: Boolean,
  },
  data() {
    return {
      period: "1d",
      periods: ["30min", "1h", "1d", "3d", "7d"],
      loading: true,
      controller: null,
      noChartWarning: "",
      hasChart: false,
      hasCharts: false,
      apex: null, //apex
      selected: null,
      selectedRight: null,
      info: {},
      series: [],
      options: {},
      colNamesRight: [],
      // serieNameChart: "",
      colNamesRight: [],
      colorChart: {
        type: "solid",
        opacity: 0.1,
        gradient: {
          type: "vertical",
          shade: "dark",
          shadeIntensity: 0.5,
          opacityFrom: 0.7,
          opacityTo: 0.3,
          stops: [0, 50, 100],
        },
      },
      annotationChartDate: "",
      annotationChartTime: "",
      annotationChartData: "",
      annotationChartNote: "",
      tableData: [],
      minDate: "",
      maxDate: "",
      feedbackSensorName: null,
      feedbackMeasure: null,
      feedbackInfo: null,
    };
  },
  created() {
    window.moment = moment;
    this.selected = this.colNames[0];
    this.colNamesRight = this.colNames
      .map((e) => e)
      .filter((e) => e.text !== "VOLUME" && e.text !== "LÂMINA");
    this.colNamesRight.unshift({ value: "", text: "SELECIONAR" });
    // Pré-seleciona ATUAÇÃO por padrão: evita o clique extra em "SELECIONAR"
    // para ver o estado on/off junto da medida principal.
    this.selectedRight =
      this.colNamesRight.find((c) => c.text === "ATUAÇÃO") ||
      { value: null, text: "SELECIONAR" };
    this.controller = new AbortController();
    if (this.eqp) {
      this.callChart(this.eqp, this.name, this.columns);
    } else {
      this.loading = false;
      this.hasChart = false;
      this.noChartWarning = "Não foi identificado o equipamento do gráfico.";
    }
    if (this.hasFeedbackSensor) {
      this.resolveFeedbackSensor();
    }
  },
  beforeDestroy() {
    this.controller.abort();
    this.$emit("reset");
  },
  watch: {
    annotationChartDate(v) {
      console.log("DATE ", v);
    },
    selectedRight(newValue) {
      if (newValue.text === "SELECIONAR") {
        if (this.series.length > 1) {
          this.selectedRight = { value: null, text: "SELECIONAR" };
          this.buildActuatorInfo();
        }
      } else if (newValue.value && this.series[0] && this.series[0].name) {
        this.buildActuatorInfoRight();
      }
    },
  },
  computed: {
    // ATUAÇÃO (on/off) e o sensor de feedback são só contexto visual dentro do
    // gráfico — não têm um card de destaque próprio (Mín/Média/Máx não fazem
    // sentido pra um sinal binário, e o feedback já se identifica pelo subtítulo).
    highlights() {
      let highlights = [];
      for (let i = 0; i < this.series.length; i++) {
        const s = this.series[i];
        if (s.hideHighlight) continue;
        let pos = null;
        if (s.data && s.data.length) {
          let logs = s.data.map((e) => Number(e[1]));
          let max = Math.max(...logs);
          let min = Math.min(...logs);
          let avg = (logs.reduce((acc, e) => acc + e, 0) / logs.length).toFixed(
            2
          );
          let length = logs.length;
          if (
            (i === 0 && this.selected.text === "VAZÃO") ||
            (i === 1 && this.selectedRight.text === "VAZÃO")
          ) {
            let logsNotNull = logs.filter((e) => !!e);
            length = logsNotNull.length;
            if (logsNotNull.length) {
              avg = (
                logsNotNull.reduce((acc, e) => acc + e, 0) / logsNotNull.length
              ).toFixed(2);
              min = Math.min(...logsNotNull);
            }
          }
          let maxDates = s.data.filter((e) => e[1] == max).map((e) => e[0]);
          let minDates = s.data.filter((e) => e[1] == min).map((e) => e[0]);
          highlights.push({
            name: s.name,
            unit: s.unit,
            pos,
            max,
            maxDates,
            min,
            minDates,
            avg,
            length,
            color: s.c,
          });
        } else {
          highlights.push({
            name: s.name,
            unit: s.unit,
            pos,
            max: "?",
            maxDates: "",
            min: "?",
            minDates: "",
            avg: "?",
            length: "?",
            color: s.c,
          });
        }
      }
      return highlights;
    },
  },
  methods: {
    createTable(data) {
      // this.showTabulator = false;
      this.tableData = [];
    },
    changeDropdownLeft(newValue) {
      if (newValue) {
        this.selected = newValue;
        this.options = {};
        this.series = [];
        this.hasChart = false;
        this.hasCharts = false;
        if (
          this.selected.text === "VOLUME" ||
          this.selected.text === "LÂMINA"
        ) {
          this.selectedRight = { value: null, text: "SELECIONAR" };
        }
        this.changeDataByPeriod(this.period);
      }
    },
    formatDate(unix) {
      if (unix) {
        if (unix.length == 1) return moment(unix[0]).format("DD/MM/YYYY HH:mm");
        else
          return `${moment(unix[unix.length - 1]).format("DD/MM/YYYY HH:mm")}`;
      }
    },
    changeDataByPeriod(p) {
      this.period = p;
      let now = moment();
      let today0h = moment({ hour: 0, minute: 0, seconds: 0, milliseconds: 0 });
      let period = null;
      switch (p) {
        case "7d":
          break;
        case "3d":
          period = today0h.subtract(3, "days").format("YYYY-MM-DD HH:mm");
          break;
        case "1d":
          period = today0h.subtract(1, "days").format("YYYY-MM-DD HH:mm");
          break;
        case "1h":
          period = now.subtract(1, "hours").format("YYYY-MM-DD HH:mm");
          break;
        case "30min":
          period = now.subtract(30, "minutes").format("YYYY-MM-DD HH:mm");
          break;
      }
      if (this.selectedRight && this.selectedRight.value) {
        this.buildActuatorInfoRight(period);
      } else {
        this.buildActuatorInfo(period);
      }
      this.buildFeedbackSeries(period);
      this.applyStrokeCurves();
    },
    getTimestamp(datetime) {
      let dt = datetime.replace(/ /g, "T");
      return Math.round(new Date(dt).getTime());
    },
    // Linhas de referência min/max no gráfico de VAZÃO. min/max vêm de
    // MIN_FLOW/MAX_FLOW da válvula (organizeLog em charts.js); bombas não têm
    // esses limites configurados e chegam com os valores-sentinela
    // -1000000/1000000 (ver charts.js), por isso o filtro de faixa abaixo.
    buildFlowAnnotations(min, max, unit) {
      const lines = [];
      if (min > 0) {
        lines.push({
          y: min,
          borderColor: "#c13745",
          strokeDashArray: 4,
          label: {
            borderColor: "#c13745",
            style: { color: "#fff", background: "#c13745" },
            text: `Mínimo: ${min} ${unit}`,
          },
        });
      }
      if (max > 0 && max < 1000000) {
        lines.push({
          y: max,
          borderColor: "#edad49",
          strokeDashArray: 4,
          label: {
            borderColor: "#edad49",
            style: { color: "#fff", background: "#edad49" },
            text: `Máximo: ${max} ${unit}`,
          },
        });
      }
      return lines;
    },
    buildActuatorInfo(p) {
      if (Object.keys(this.info).length) {
        let filter = 0;
        if (p) filter = this.getTimestamp(p);
        let name = this.info.name;
        let { data, type, measure, unit, max, min, curve } =
          this.info[this.selected.value];
        this.series = [
          {
            name: `Leituras de ${measure}`,
            unit,
            data: this.generateDataChart(data, filter),
            c: "#007bff",
            hideHighlight: this.selected.text === "ATUAÇÃO",
          },
        ];
        this.options = {
          chart: {
            id: `apexchart`,
            height: 425,
            width: "100%",
            type: this.changeTypeChart(this.selected.text),
            // type: this.selected.text === "VOLUME" || this.selected.text === "LÂMINA"?'bar':'line',
            stacked: false,
            zoom: {
              enabled: true,
              autoScaleYaxis: true,
            },
            animations: {
              enabled: false,
            },
            toolbar: {
              export: {
                csv: {
                  headerCategory: "Data",
                  filename: "Dados do gráfico",
                  dateFormatter(timestamp) {
                    return moment(timestamp).format("DD/MM/YYYY HH:mm");
                  },
                },
              },
              offsetY: -2,
            },
          },
          xaxis: {
            type: "datetime",
            labels: {
              datetimeUTC: false,
              format: "dd/MM/yyyy HH:mm",
              rotateAlways: false,
            },
          },
          stroke: {
            curve: "smooth",
            width: [2, 2, 2],
            // width: [4, 4],
          },
          title: {
            text: `${name} - ${measure} (${unit ? unit : "Sem unidade"})`,
            align: "left",
            offsetX: 10,
            offsetY: 15,
          },
          dataLabels: {
            enabled: false,
          },
          yaxis: [
            {
              min: 0,
              axisTicks: {
                show: false,
              },
              logarithmic: false,
              opposite: false,
              axisBorder: {
                show: false,
                color: "#000",
              },
              labels: {
                // minWidth: 20,
                offsetX: 0,
                align: "left",
                rotate: 0,
                style: {
                  fontSize: "10px",
                  colors: "#008FFB",
                },
                formatter: function (value) {
                  return `${value.toFixed(2)}`;
                },
              },
              title: {
                // text: ``,
                show: false,
                style: {
                  color: "#008FFB",
                },
              },
              min: 0,
            },
          ],
          annotations: {
            yaxis:
              this.selected.text === "VAZÃO"
                ? this.buildFlowAnnotations(min, max, unit)
                : [],
          },
          tooltip: {
            // O tooltip nativo em modo "shared" do ApexCharts não casa direito os
            // índices entre séries de resoluções diferentes (VAZÃO/ATUAÇÃO têm uma
            // leitura por evento do atuador; o Feedback vem de um sensor com
            // frequência própria, bem mais densa) — na prática só a primeira série
            // do array chegava a aparecer. Renderiza à mão: pega o timestamp do
            // ponto que o hover nativo encontrou (sempre correto pra UMA série) e
            // busca, em cada série, o ponto mais próximo desse mesmo timestamp.
            custom: (opts) => this.renderTooltip(opts),
          },
          legend: {
            show: true,
            position: "bottom",
            markers: { width: 10, height: 10 },
            itemMargin: { horizontal: 8, vertical: 4 },
          },
        };
        if (!this.selectedRight.value) {
          this.options.fill = { ...this.colorChart };
        } else if (this.selectedRight.value) {
          this.options.fill = { ...this.colorChart };
          this.options.fill.opacity = 1;
        }
        setTimeout((_) => {
          this.loading = false;
          this.hasChart = true;
        }, 150);
      }
    },
    buildActuatorInfoRight(p) {
      if (Object.keys(this.info).length) {
        p ? this.buildActuatorInfo(p) : this.buildActuatorInfo();
        let filter = 0;
        if (p) filter = this.getTimestamp(p);
        let name = this.info.name;
        let { data, type, measure, unit, max, min, curve } =
          this.info[this.selectedRight.value];
        // A escala de ATUAÇÃO é binária (0/1) — mostrar um eixo numérico pra ela
        // só confunde, então a série continua no gráfico mas sem eixo visível.
        const isAtuacao = this.selectedRight.text === "ATUAÇÃO";
        let series = [];
        series = [
          {
            name: `Leituras de ${measure}`,
            unit,
            type: "line",
            data: this.filterSeriesData(data, filter),
            c: "#4ba05f",
            hideHighlight: isAtuacao,
          },
        ];
        let options = {
          yaxis: {
            min: 0,
            max: isAtuacao ? 1 : undefined,
            show: !isAtuacao,
            axisTicks: {
              show: false,
            },
            logarithmic: false,
            opposite: false,
            axisBorder: {
              show: false,
              color: "#000",
            },
            title: {
              show: false,
              style: {
                color: "#28a745",
              },
            },
            labels: {
              offsetX: -10,
              style: {
                fontSize: "10px",
                colors: "#28a745",
              },
            },
          },
        };
        if (series.length > 1) {
          series.forEach((e) => {
            this.series.push(e);
          });
        } else {
          this.series.push(series[0]);
        }
        this.options.yaxis.push(options.yaxis);
      }
    },
    // Anexa a leitura do sensor de feedback (ex: pressão) como uma série extra no
    // mesmo gráfico do atuador, com eixo próprio (à direita) — evita ter dois
    // gráficos separados e desalinhados no tempo. Roda sempre por último: se ainda
    // não tiver resolvido o sensor, ou o gráfico principal ainda não montou o
    // options.yaxis, não faz nada (é chamado de novo quando o histórico chegar).
    buildFeedbackSeries(p) {
      if (!this.feedbackInfo || !this.options || !this.options.yaxis) return;
      let filter = 0;
      if (p) filter = this.getTimestamp(p);
      const { data, unit, color, decimals } = this.feedbackInfo;
      this.series.push({
        // O nome do sensor aparece na legenda (abaixo do gráfico), com uma
        // bolinha na cor da linha — não precisa de subtítulo/card extra.
        name: `Feedback: ${this.feedbackSensorName}${unit ? ` (${unit})` : ""}`,
        unit,
        type: "line",
        data: this.filterSeriesData(data, filter),
        c: color,
        hideHighlight: true,
      });
      this.options.yaxis.push({
        min: 0,
        opposite: true,
        axisTicks: { show: false },
        axisBorder: { show: false, color },
        title: { show: false },
        labels: {
          offsetX: 6,
          style: { fontSize: "10px", colors: color },
          formatter: (v) => `${Number(v).toFixed(decimals)}`,
        },
      });
    },
    // ATUAÇÃO é um sinal ligado/desligado — "smooth" desenha uma curva arredondada
    // entre 0 e 1 que parece um bloco, em vez do degrau que representa o estado real.
    applyStrokeCurves() {
      if (!this.options || !this.options.stroke) return;
      this.options.stroke.curve = this.series.map((s, i) => {
        const isAtuacao =
          (i === 0 && this.selected && this.selected.text === "ATUAÇÃO") ||
          (i === 1 && this.selectedRight && this.selectedRight.text === "ATUAÇÃO");
        return isAtuacao ? "stepline" : "smooth";
      });
      this.options.stroke.width = this.series.map(() => 2);
      // Garante que a linha desenhada, a bolinha da legenda e o card de
      // destaque usem sempre a mesma cor por série.
      this.options.colors = this.series.map((s) => s.c);
    },
    // Ver comentário em options.tooltip.custom (buildActuatorInfo) — reimplementa
    // a busca do ponto "mais próximo" por série, já que o modo shared nativo do
    // ApexCharts não dá conta de séries com resoluções/tamanhos diferentes.
    // Estilo 100% inline: o HTML retornado aqui é injetado via innerHTML pelo
    // próprio ApexCharts, fora do template do componente — CSS scoped do Vue não
    // alcança esse nó, então não dá pra depender de classe com <style scoped>.
    renderTooltip({ seriesIndex, dataPointIndex, w }) {
      const g = w.globals;
      const refX = g.seriesX[seriesIndex] && g.seriesX[seriesIndex][dataPointIndex];
      if (refX == null) return "";
      const rows = g.seriesNames
        .map((name, i) => {
          const xs = g.seriesX[i];
          if (!xs || !xs.length) return "";
          let closestIdx = 0;
          let closestDist = Infinity;
          for (let j = 0; j < xs.length; j++) {
            const dist = Math.abs(xs[j] - refX);
            if (dist < closestDist) {
              closestDist = dist;
              closestIdx = j;
            }
          }
          const value = g.series[i][closestIdx];
          if (value === null || value === undefined) return "";
          return `<div style="display:flex;align-items:center;gap:6px;padding:3px 10px;">
            <span style="width:9px;height:9px;border-radius:50%;flex-shrink:0;background:${g.colors[i]}"></span>
            <span>${name}: <b>${Number(value).toFixed(2)}</b></span>
          </div>`;
        })
        .filter(Boolean)
        .join("");
      return `<div style="background:#fff;border-radius:4px;overflow:hidden;font-size:12px;min-width:160px;">
        <div style="padding:5px 10px;font-weight:600;border-bottom:1px solid #eee;background:#f5f6f5;">${moment(refX).format("DD/MM/YYYY HH:mm")}</div>
        ${rows}
      </div>`;
    },
    resolveFeedbackSensor() {
      const listCall = this.isPump ? listEquipments.pumps() : listEquipments.valves();
      Promise.all([listCall, listEquipments.sensors()])
        .then(([actuators, sensorsRet]) => {
          const list = Array.isArray(actuators) ? actuators : [];
          const target = Number(this.actuatorId);
          const row = list.find((a) => Number(a.ID) === target);
          if (!row || !row.FK_SENSOR) return;
          const aux = ((sensorsRet && sensorsRet.aux) || []).find(
            (a) => Number(a.ID) === Number(row.FK_SENSOR) && Number(a.POS) === Number(row.POS_SENSOR)
          );
          if (!aux) return;
          this.feedbackSensorName = row.NAME_SENSOR || aux.NAME;
          this.feedbackMeasure = {
            type: aux.NAME_TYPE,
            unit: aux.NAME_UNIT,
            label: (aux.NAME_TYPE || "FEEDBACK").toUpperCase(),
            // Roxo — precisa ser bem distinto do azul de VAZÃO (#007bff) e do
            // verde de ATUAÇÃO (#4ba05f); o teal usado antes (#298abe) ficava
            // parecido demais com o azul de VAZÃO.
            color: "#8a5cc9",
            decimals: 2,
          };
          this.fetchFeedbackHistory();
        })
        .catch((err) => console.error(err));
    },
    fetchFeedbackHistory() {
      const end = moment();
      const start = moment().subtract(1, "week").hours(0).minutes(0);
      const data = {
        EQP: "SENSOR",
        NAME: this.feedbackSensorName,
        COLUMN: "UNIT",
        CONDITION: {
          TYPES: [this.feedbackMeasure.type],
          UNITS: [this.feedbackMeasure.unit],
        },
        START: start.format("YYYY-MM-DD HH:mm"),
        END: end.format("YYYY-MM-DD HH:mm"),
      };
      monitChart
        .create(data, this.controller)
        .then((ret) => {
          if (!ret.status) throw new Error(ret.log || "Falha ao buscar histórico do sensor de feedback.");
          return organizeLog(
            ret,
            "SENSOR",
            this.feedbackSensorName,
            [{ TYPE: this.feedbackMeasure.type, UNIT: this.feedbackMeasure.unit, PER_READING: true }],
            "chartsPage"
          );
        })
        .then((result) => {
          const info = result.status ? result.value[this.feedbackMeasure.type] : null;
          if (!info || !info.data || !info.data.length) return;
          this.feedbackInfo = { ...this.feedbackMeasure, data: info.data };
          this.changeDataByPeriod(this.period);
        })
        .catch((err) => console.error(err));
    },
    generateDataChart(data, filter) {
      let result;
      try {
        if (data.length) {
          result = data.filter((e) => e[0] > filter);
          if (!result.length > 0) {
            throw `Não existe dados para o período de ${this.period} especificado.`;
          }
          return result.length ? result : [];
        } else {
          return data;
        }
      } catch (error) {
        if (this.selectedRight.value !== null) {
          alert(error);
          this.buildActuatorInfo();
          this.buildActuatorInfoRight();
        } else {
          alert(error);
          this.buildActuatorInfo();
        }
        return [];
      }
    },
    // Filtro silencioso (sem alert/recuperação) para séries secundárias
    // (ATUAÇÃO, feedback): dado ausente ou vazio no período não deve travar
    // ou reconstruir o gráfico principal, só resulta numa linha vazia.
    filterSeriesData(data, filter) {
      if (!data || !data.length) return data || [];
      // O histórico de sensor (usado pelo Feedback) chega do backend em ORDER BY
      // TIME DESC — sem reordenar, a série ficava com o eixo X fora de ordem, o
      // que quebra a busca de "ponto mais próximo" no tooltip (renderTooltip).
      return data.filter((e) => e[0] > filter).sort((a, b) => a[0] - b[0]);
    },
    fetchEventsPage(page) {
      return monitChart
        .events({ NAME: this.name, PAGE: page }, this.controller)
        .then((ret) => ({
          rows: ret.status
            ? ret.value.map(({ TIME, NOTE }) => ({ NAME: TIME, VALUE: NOTE }))
            : [],
          total: ret.more ? ret.more.total : 0,
          totalPages: ret.more ? ret.more.totalPages : 0,
        }));
    },
    createEvent(note) {
      return monitChart
        .createEvent({ EQP: "ACTUATOR", NAME: this.name, NOTE: note })
        .then((ret) => {
          if (!ret.status) throw ret.log || "Erro ao adicionar evento.";
          return ret;
        });
    },
    callChart(EQP, NAME, columns) {
      let START = moment()
        .subtract(1, "week")
        .hours(0)
        .minutes(0)
        .format("YYYY-MM-DD HH:mm");
      let END = moment().format("YYYY-MM-DD HH:mm");
      let len = columns.length;
      let data = {
        EQP,
        NAME,
        COLUMN: EQP != "SENSOR" ? columns : "UNIT",
        CONDITION:
          EQP != "SENSOR"
            ? "where"
            : {
              TYPES: columns.map((e) => e.TYPE),
              UNITS: columns.map((e) => e.UNIT),
            },
        START,
        END,
      };
      monitChart
        .create(data, this.controller)
        .then((ret) => {
          if (ret && ret.value && ret.value[0] && ret.value[0].length && ret.value[0][0].IS_FIR) {
            ret.value[0].map(log => {
              if (log.NOTE && log.NOTE.toUpperCase().includes("DESATIVADO")) {
                log.OPEN = 1;

              } else if (log.NOTE && log.NOTE.toUpperCase().includes("ATIVADO") || log.OPEN) {
                log.VOL_VALUE = 0;
                log.OPEN = 1;

              } else {
                log.OPEN = 0;
                log.VOL_VALUE = 0;
              }

              return log;
            })
          }

          let result = ret;
          if (result.value[0].length && result.status) {
            return organizeLog(result, EQP, NAME, this.columns, null, this.area);
          } else {
            alert(result.log, "w");
            throw new Error(result.log);
          }
        })
        .then((reportData) => {
          // if (e.status) this.drawApexSyncCharts(e.value); //apex sync
          if (reportData.status) {
            this.info = reportData.value;
            this.changeDataByPeriod(this.period);
          } else {
            this.loading = false;
            this.hasChart = false;
            this.noChartWarning = reportData.log;
          }
        })
        .catch((err) => {
          this.loading = false;
          this.hasChart = false;
          console.error(err);
          this.noChartWarning = "Não foi possível desenhar o gráfico.";
        });
    },
    changeTypeChart(type) {
      if (type === "VOLUME" || type === "LÂMINA") {
        return "bar";
        // return "line";
      } else if (this.selectedRight.value === null) {
        return "area";
      } else if (this.selectedRight.value) {
        return "line";
      }
    },
  },
};
</script>

<style scoped>
.graficos {
  min-height: 425px;
}


.chart-div {
  position: relative;
}

.highlights h4 {
  margin: 0;
}

.highlights .hl-detail {
  display: block;
  font-size: 12px;
  color: #777;
}

.container-buttons-left {
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
}

.highlights div:first-child {
  margin-bottom: 4px;
}

.highlights .card-name {
  margin-bottom: 8px;
  padding-bottom: 4px;
  font-size: 1.2em;
  padding: 4px 2px;
  text-align: center;
}

.card-container {
  border: solid 1px #dedede;
  padding: 0 -14px;
}

.label {
  display: none;
}

@media (max-width: 767px) {
  .container-dropdown {
    padding-top: 0em;
  }

  .btn-left {
    padding: 0;
  }

  .container-buttons .dropdown+.dropdown {
    margin-top: 4px;
  }
}
</style>
